export default {
  settingAssignGoods: {
    code: 'Product Code',

    table: {
      name: 'Product Name',
      price: 'Specified Logistics',
      business: 'Specified Logistics Service',
      updater: 'Updated By',
      lastUpdater: 'Last Updated Time'
    },

    addAndEdit: {
      editCommodity: 'Edit specified product configuration',
      addCommodity: 'Create specified product configuration',
      business: 'Specified Business',
      codePlaceholder: 'Please Select Product',
      selectCommodity: 'Select Product',
      logisticsText: 'Please select the associated logistics provider first',
      logisticsRules: 'Please select the specified logistics',
      businessRules: 'Please select the specified business'
    }
  }
};
